












import IconRequired from "@/common/components/icons/IconRequired.vue";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    IconRequired
  }
})
export default class FormLabel extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) required!: boolean;
}
